import BookForm from "components/shared/book/form";
import { Datetime } from "components/shared/form";
import { serializeReq } from "helpers/form";
import { paths } from "helpers/paths";
import moment from "moment";
import React, { Fragment } from "react";
import { config, initialState } from "./config";
import Markup from "./markup";

class FormCalculationQueue extends BookForm {
    renderDateField = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const libOptions = { ...props.libOptions };
        if (this.state.from && props.inputProps.name === "to") {
            libOptions.minDate = moment(this.state.from);
            const maxPeriodDate = moment(this.state.from).add(13, "d");
            if (maxPeriodDate < libOptions.maxDate) {
                libOptions.maxDate = maxPeriodDate;
            }
        }
        if (this.state.to && props.inputProps.name === "from") {
            libOptions.minDate = moment(this.state.to).subtract(13, "d");
            if (moment(this.state.to) < libOptions.maxDate) {
                libOptions.maxDate = moment(this.state.to);
            }
        }
        return (
            <Datetime
                key={props.label}
                onChange={this.setValue}
                value={this.state[props.inputProps.name]}
                errorWrapper="col-sm-8 col-md-9 offset-sm-4 offset-md-3"
                {...props}
                libOptions={libOptions}
            />
        );
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, isValid, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                state.carIds = state.carIds.split(",").map((item) => parseInt(item.trim()));
                const formatted = serializeReq(state);
                formatted.from = moment(formatted.from).format("YYYY-MM-DD");
                formatted.to = moment(formatted.to).format("YYYY-MM-DD");
                return this.applyReq(formatted);
            }
            this.setState({ isValid: false });
        }
    };

    applyReq = (serialized) => {
        this.setState({ result: [] });
        return this.props.submit(serialized).then((result) => {
            if (result) {
                this.setState({ result, isLoading: false, isValid: false });
            } else {
                this.setState({ isLoading: false, isValid: false });
            }
        });
    };

    renderResult = () => {
        return (
            <div className="table-responsive">
                <table className="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Машина</th>
                            <th>Результат</th>
                            <th>Заявки</th>
                            <th>Ошибка</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.result.map((item, index) => (
                            <tr key={index}>
                                <td>{item.addition ? item.addition.carId : ""}</td>
                                <td>{item.isOk ? "Успешно" : "Ошибка"}</td>
                                <td>
                                    {item.addition &&
                                        item.addition.bidIds.map((bidId) => (
                                            <Fragment key={bidId}>
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={paths.bidShow("bid", bidId)}
                                                >
                                                    {bidId}
                                                </a>
                                                ,&nbsp;
                                            </Fragment>
                                        ))}
                                </td>
                                <td>{item.message}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    renderBody = () => {
        const { config } = this.props;
        return (
            <Fragment>
                <Markup
                    {...config}
                    renderField={this.renderField}
                    renderSelect={this.renderSelect}
                    renderDateField={this.renderDateField}
                    renderFlags={this.renderFlags}
                />
                {this.state.result && this.state.result.length > 0 && this.renderResult()}
            </Fragment>
        );
    };
}

const ConfiguredForm = (props) => <FormCalculationQueue {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
